import { times } from 'lodash'
import { Skeleton } from '@axilon-apps/libs-ui-shadcn'

interface Props {
  columns: number
  rows?: number
  avatarPosition?: number
  hasAvatar?: boolean
}

const TableSkeletonLoader = ({
  columns,
  rows = 6,
  avatarPosition = 0,
  hasAvatar = false
}: Props) => (
  <div className="flex flex-col gap-2 p-2">
    {times(rows, String).map((row) => (
      <div key={row} className="flex w-full flex-row items-center gap-4">
        {times(columns - (hasAvatar ? 1 : 0), String).map((key, position) =>
          position === avatarPosition && hasAvatar ? (
            <Skeleton key={key} className="size-12 min-w-12 rounded-full" />
          ) : (
            <Skeleton key={key} className="h-8 flex-1" />
          )
        )}
      </div>
    ))}
  </div>
)

export default TableSkeletonLoader
